import api from "./Client";

export type ApiNotification = {
  notification_id: number;
  user_id: number;
  title: string;
  message: string;
  created_at: string;
  updated_at?: string | null;
};

export async function fetchUserNotifications(userId: number): Promise<ApiNotification[]> {
  const res = await api.get<{ data: ApiNotification[] }>(`/api/customers/${userId}/notifications`);
  return Array.isArray(res.data?.data) ? res.data.data : [];
}

export async function deleteUserNotification(userId: number, notificationId: number) {
  return api.delete(`/api/customers/${userId}/notifications/${notificationId}`);
}

export async function createUserNotification(userId: number, payload: {
  title: string;
  message: string;
  type?: string;
}) {
  const res = await api.post<{ data?: ApiNotification }>(
    `/api/customers/${userId}/notifications`,
    payload
  );
  return res.data?.data;
}
